import React from 'react'
import { CaseBtn } from './CaseListUI'

function RequestToViewBtn({onReq}) {
  return <CaseBtn onClick={onReq}>Request to view more →</CaseBtn>
}

export default RequestToViewBtn
